import { render, staticRenderFns } from "./BigHeaderCatalogView.vue?vue&type=template&id=005feaaa&scoped=true&"
import script from "./BigHeaderCatalogView.vue?vue&type=script&lang=js&"
export * from "./BigHeaderCatalogView.vue?vue&type=script&lang=js&"
import style0 from "./BigHeaderCatalogView.vue?vue&type=style&index=0&id=005feaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005feaaa",
  null
  
)

export default component.exports